import { create } from "zustand";
import type { ExecutionPerformanceState } from "./types";

const useExecutionPerformanceStore = create<ExecutionPerformanceState>((set) => ({
    executionPerformanceData: undefined,
    setExecutionPerformanceData: (data) => set({ executionPerformanceData: data }),
}));

export { useExecutionPerformanceStore };
